/* eslint-disable import/no-anonymous-default-export */
import {
  CREATEUSER,
  DELETEUSER,
  UPDATEUSER,
  FETCHUSERS,
  FETCHUSER,
} from "../constants/actionTypes";

export default (users = [], action) => {
  switch (action.type) {
    case DELETEUSER:
      return users?._id !== action?.payload?._id;
    case UPDATEUSER:
      return users?._id === action?.payload._id ? action?.payload : users;
    case FETCHUSERS:
      return action.payload;
    case FETCHUSER:
      return action.payload;
    case CREATEUSER:
      return [...users, action.payload];
    default:
      return users;
  }
};
